<template>
  <div id="app">
    <Login @login="login" v-if="logouted" />
    <Layout @logout="logout" v-if="logined" />
  </div>
</template>

<script>
import Layout from "./components/Layout";
import Login from "./components/Login";
export default {
  name: "app",
  components: {
    Layout,
    Login,
  },
  data() {
    return {
      logouted: true,
      logined: false,
      users: {},
    };
  },
  methods: {
    login() {
      this.users = JSON.parse(localStorage.getItem("user"));
      const loginer = localStorage.getItem("loginer");
      if (loginer) {
        this.logined = true;
        this.logouted = false;
      }
      if (this.users.role == 0) {
        this.$router.push({
          name: "User",
        });
      } else {
        this.$router.push({
          name: "usePerformance",
        });
      }
    },
    logout() {
      this.logouted = true;
      this.logined = false;
      this.$router.push("/login");
    },
    loginCheck() {
      const loginer = localStorage.getItem("loginer");
      if (loginer) {
        this.logined = true;
        this.logouted = false;
      } else {
        this.logouted = true;
        this.logined = false;
      }
    },
    check() {
      this.$http.interceptors.request.use(undefined, function (err) {
        return new Promise((resolve, reject) => {
          if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            this.$store.dispatch(logout);
          }
          throw err;
        });
      });
    },
  },
  created() {
    this.check();
    this.loginCheck();
  },
};
</script>

<style lang="scss">
html,
body,
#app,
.el-container {
  padding: 0;

  margin: 0;

  height: 100%;
}
</style>
